import { make } from "vuex-pathify"
import { AssetOwnerService } from "../services/asset-owner.service.js"
import Logger from "@/lib/logger.js"

const service = new AssetOwnerService()

export const state = {
  assetOwners: [],
  collateralOwners: [],
}

export const mutations = {
  ...make.mutations(state)
}

export const actions = {
  async getAssetOwners({ commit }, { page, limit, order, sort, search, excludedIds }) {
    try {
      const { data } = await service.getAssetOwners(page, limit, order, sort, search, excludedIds);
      commit('SET_ASSET_OWNERS', data.assetOwners);
      return data;
    } catch (error) {
      Logger.error('Getting Asset Owners');
      throw error;
    }
  },

  async createAssetOwner({ dispatch }, assetOwner) {
    try {
      const { data } = await service.createAssetOwner(assetOwner);
      return data;
    } catch (error) {
      Logger.error('Create Asset Owners');
      throw error;
    }
  },

  async updateAssetOwner({ dispatch }, { id, updates }) {
    try {
      const { data } = await service.updateAssetOwner(id, updates);
      return data;
    } catch (error) {
      Logger.error('Updating Asset Owners');
      throw error;
    }
  },

  async deleteAssetOwner({ dispatch  }, id) {
    try {
      const { data } = await service.deleteAssetOwner(id);
      return data;
    } catch (error) {
      Logger.error('Deleting Asset Owners');
      throw error;
    }
  },

  async addOwnerToInsurance(_, { ownerId, insuranceId, owner }) {
    try {
      const { data } = await service.addOwnerToInsurance(ownerId, insuranceId, owner);
      return data;
    } catch (error) {
      Logger.error('Deleting Asset Owners');
      throw error;
    }
  },

  async removeOwnerFromInsurance( _, { ownerId, insuranceId }) {
    try {
      const { data } = await service.removeOwnerFromInsurance(ownerId, insuranceId);
      return data;
    } catch (error) {
      Logger.error('Deleting Asset Owners');
      throw error;
    }
  }
}